import format from 'date-fns/format';

export default date => format(date, 'MMMM d, yyyy');
